import PopoverHint from '@sweetspot/club-portal-legacy/components/PopoverHint/PopoverHint'

type BucketSizesBoxProps = {
  title: string
  description: string
  hint?: React.ReactNode
  children: React.ReactNode
}

const BucketSizesBox = ({ title, description, hint, children }: BucketSizesBoxProps) => (
  <div className="border-background-mono-light bg-background-base-neutral rounded-md border py-4">
    <div className="border-background-mono-light flex items-start justify-between border-b px-4 pb-4">
      <div>
        <div className="text-content-lg font-bold">{title}</div>
        <div className="text-content-sm text-text-subtle">{description}</div>
      </div>
      {hint && (
        <div className="pt-1">
          <PopoverHint hintContent={hint} />
        </div>
      )}
    </div>
    <div className="px-4 pt-4">{children}</div>
  </div>
)

export default BucketSizesBox
